export const remConvert = (unit: number): string => {
  return `${unit / 16}rem`;
};
